import React, { useEffect, useState } from 'react';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past approx hero height (e.g., 500px)
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPurchase = () => {
    document.getElementById('purchase-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className={`fixed top-0 left-0 w-full z-50 bg-[#ffb3bb] shadow-md transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`} data-id="element-206">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-center items-center" data-id="element-207">
        <button onClick={scrollToPurchase} className="text-stone-900 font-bold text-base md:text-lg hover:scale-105 transition-transform" data-id="element-208">
          ¡Aprovechá la oferta especial de hoy! Clic acá
        </button>
      </div>
    </div>;
}